<template>
  <div class="personPage">
    <XR-head titleText="个人资料" :rightShow="false" ref="headObj"></XR-head>
    <div class="person-row person-row-img">
      <div class="person-col person-title">头像</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>  
      <div class="person-col person-content headpicRow">
        <img :src="headpic" class="person-headpic" @click="$refs.headpicFile.click()" />
        <input class="headpicInput" name="file" type="file" ref="headpicFile"  @change="update"/>
        <!-- accept="image/png,image/gif,image/jpeg" -->
      </div>  
    </div>
    <div class="person-row">
      <div class="person-col person-title">用户名</div>  
      <!-- <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>   -->
      <div class="person-col person-content">
        <mu-flat-button :label="userInfo.user_name" class="demo-flat-button"/>
        <!-- <mu-bottom-sheet :open="bottomNickSheet" @close="closeNickBottomSheet">
          <mu-row class="personPage-nick">
            <mu-col>
              <mu-text-field label="昵称" v-model="nickText" helpText="长度为25个字符" fullWidth/>
            </mu-col>
            <mu-col>
              <mu-raised-button label="确 定" class="demo-raised-button" primary fullWidth @click="SetNick()" />
            </mu-col>
          </mu-row>
        </mu-bottom-sheet> -->
      </div>
    </div>
    <div class="person-row">
      <div class="person-col person-title">昵称</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>  
      <div class="person-col person-content">
        <mu-flat-button :label="nickText?nickText:'请输入昵称'" class="demo-flat-button" style="text-transform:none" @click="openNickBottomSheet"/>
        <mu-bottom-sheet :open="bottomNickSheet" @close="closeNickBottomSheet">
          <mu-row class="personPage-nick">
            <mu-col>
              <mu-text-field label="昵称" v-model="nickTextVal" helpText="长度为25个字符" fullWidth/>
            </mu-col>
            <mu-col>
              <mu-raised-button label="确 定" class="demo-raised-button" primary fullWidth @click="SetNick()" />
            </mu-col>
          </mu-row>
        </mu-bottom-sheet>
      </div> 
    </div>
    <!-- <div class="person-row">
      <div class="person-col person-title">积分</div>  
      <div class="person-col person-rightIcon">
        <router-link to='/integralShop'><mu-flat-button  to="/integralShop" label="积分兑换" class="demo-flat-button link-btn"/></router-link>
      </div>
      <div class="person-col person-content">
        <mu-flat-button :label="userInfo.Integral" class="demo-flat-button"/>
      </div>
    </div> -->
    <div class="person-row">
      <div class="person-col person-title">金币</div>  
      <div class="person-col person-rightIcon">
        
        <mu-flat-button  to="/usercenter/coinRecharge" label="充值" v-if="false" class="demo-flat-button link-btn"/>		
        <mu-flat-button v-if="!closeCoinWithdraw" to="/usercenter/coinWithdraw" label="提现" class="demo-flat-button link-btn"/>
		    <mu-flat-button v-if="isCoinTransfer" to="/usercenter/coinTransfer" label="转账" class="demo-flat-button link-btn"/>
      </div>
      <div class="person-col person-content" style="float:right;">
        <mu-flat-button :label="userInfo.Money.toFixed(2)" class="demo-flat-button"/>
      </div>
    </div>
    <!--
    <div class="person-row">
      <div class="person-col person-title">会员级别</div>  
      <div class="person-col person-content">
        <mu-flat-button label="初级会员" class="demo-flat-button"/>
      </div>
    </div>
    -->
	<div class="person-row" v-if="UserBs > 0">
      <div class="person-col person-title">代理级别</div>  
      <div class="person-col person-content">
        <mu-flat-button :label="userInfo.UserBsName" class="demo-flat-button"/>
      </div>
    </div>
	<div class="person-row" v-if="UserBs == 6 || UserBs == 7 || UserBs == 8">
      <div class="person-col person-title">代理区域</div>
      <div class="person-col person-content">
        <mu-flat-button :label="userInfo.areainfo" class="demo-flat-button"/>
      </div>
    </div>
    <div class="person-row">
      <div class="person-col person-title">真实姓名</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>
      <div class="person-col person-content">
        <mu-flat-button  to='/usercenter/safe' :label="userInfo.ReallyName?userInfo.ReallyName:'未认证'" class="demo-flat-button"/>
      </div>
    </div>
    <div class="person-row">
      <div class="person-col person-title">性别</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>  
      <div class="person-col person-content">
        <mu-flat-button :label="sexText" class="demo-flat-button" @click="openBottomSheet" primary/>
        <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">
          <mu-list>
            <mu-sub-header>
              请选择
            </mu-sub-header>
            <mu-list-item title="男" @click="sexSelectClick(0,'男')" />
            <mu-list-item title="女" @click="sexSelectClick(1, '女')" />
          </mu-list>
        </mu-bottom-sheet>
      </div>  
    </div>
    <div class="person-row">
      <div class="person-col person-title">出生日期</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>  
      <div class="person-col person-content">
        <mu-date-picker :hintText="birthday" :value="birthdayVal" @change="birthChange" :underlineShow="false" style="width:100px;" />
      </div>  
    </div>
    <div class="person-row">
      <div class="person-col person-title">居住地址</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>  
      <div class="person-col person-content">
        <mu-flat-button :label="userInfo.Address && userInfo.Address.length>13?userInfo.Address.substr(0,13):userInfo.Address" class="demo-flat-button" @click="openAddressBottomSheet"/>
        <mu-bottom-sheet :open="addressBottomSheet" @close="closeAddressBottomSheet">            
          <mu-picker :slots="addressSlots" :visible-item-count="5" @change="addressChange" :values="address" @itemClick="closeAddressBottomSheet"/>
          <mu-row class="personPage-nick">
            <mu-col>
              <mu-text-field label="地址" v-model="addressEditInfo.DetailAddress" helpText="长度为20个字符" maxLength="20" fullWidth/>
            </mu-col>
            <mu-col>
              <mu-raised-button label="确 定" class="demo-raised-button" primary fullWidth @click="SaveAddress()" />
            </mu-col>
          </mu-row>
        </mu-bottom-sheet>
      </div>  
    </div>
    <div class="person-row">
      <div class="person-col person-title">手机号</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>
      <div class="person-col person-content">
        <mu-flat-button  :to="userInfo.IsTestPhone?'/usercenter/safe':'/usercenter/mobileBind'" :label="userInfo.mobile?userInfo.mobile:'未认证'" class="demo-flat-button"/>
      </div>
    </div>
    <!-- <div class="person-row">
      <div class="person-col person-title">邮箱</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>
      <div class="person-col person-content">
        <mu-flat-button  to='/usercenter/safe' :label="userInfo.email?userInfo.email:'未认证'" class="demo-flat-button"/>
      </div>
    </div> -->
    <div class="person-row">
      <div class="person-col person-title">身份证号</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>
      <div class="person-col person-content">
        <mu-flat-button  to='/usercenter/safe' :label="userInfo.PersonId?userInfo.PersonId:'未认证'" class="demo-flat-button"/>
      </div>
    </div>
    <div class="desc">
      <i class="fa fa-import"></i>修改手机、邮箱、身份证等实名认证信息请到账户安全
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>

var address = {
  '北京': {'北京':['北京']},
  '湖北': {'武汉':['武昌区','汉阳区','青山区'], '黄石':['黄石']},
  '台湾': {'台北市':['台北市']}
}

export default {
  name :'ucPerson',
  data () {
    return {
      bottomNav: 'movies',
      bottomNavColor: 'movies',
      bottomSheet: false,
      bottomNickSheet: false,
      sex: '0',
      sexText:'',
      nickText:'',
	  nickTextVal:'',
      birthday:'年/月/日',
	  birthdayVal:'',
      memberId:0,
      headpic:'http://frontend.xurigo.com/icon/person.jpg',
      userInfo:{Address:'', Money:0},
      UserBs:0,
      addressBottomSheet: false,
      selectAddress:'',      
      addressSlots: [
        {
          width: '100%',
          textAlign: 'right',
          values: ['北京']
        }, {
          width: '100%',
          textAlign: 'center',
          values: ['北京市']
        }, {
          width: '100%',
          textAlign: 'left',
          values: ['东城区']
        }
      ],
      address: ['北京', '北京市','东城区'],
      addressProvince: '北京',
      addressCity: '北京市',
      addressArea: '东城区',
      addressEditInfo:{
        Province : '北京',
        City:'北京市',
        Area:'东城区',
        DetailAddress:''
      }
    }
  },
  mounted: function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.getUserInfo()
    this.getAreaList()
  },
  methods: {
    getUserInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.userInfo = res.Data
		  ths.UserBs = ths.userInfo.UserBs
          ths.sex = res.Data.Sex ? res.Data.Sex :'0'
		  if (ths.sex == '0'){
			ths.sexText = '男'
		  } else {
			ths.sexText = '女'
		  }
          ths.nickText = res.Data.NickName ? res.Data.NickName :''
		  ths.nickTextVal = ths.nickText
          ths.birthday = res.Data.Birthday ? res.Data.Birthday : '年/月/日'
		  if (ths.birthday != '年/月/日')
		  {
			ths.birthdayVal =ths.birthday
		  }
          ths.memberId = res.Data.Id
          if(res.Data.HeadPic){
            ths.headpic=res.Data.HeadPic
          }
          ths.$refs.XRtoast.hide()
        }
      });      
    },
    handleChange (val) {
      this.bottomNav = val
    },
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
    sexSelectClick(sexVal,sexTextVal){
      this.sex = sexVal;
      this.sexText = sexTextVal;
      this.closeBottomSheet();
     
      
      this.$refs.XRtoast.load('请求中...', false)
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/UpdateSex",{sex : this.sex}
      ).then(function(res) {
        ths.loaded =false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });     
    },
    
    closeNickBottomSheet () {
      this.bottomNickSheet = false
    },
    openNickBottomSheet () {
      this.bottomNickSheet = true
    },
    SetNick(){
	  if (this.nickTextVal.indexOf("'")>-1){
		this.$refs.XRtoast.failed("昵称不能含有单引号", true)
		return
	  }
	  if (this.nickTextVal.indexOf('"')>-1){
		this.$refs.XRtoast.failed("昵称不能含有双引号", true)
		return
	  }
	
      this.closeNickBottomSheet();
      
      this.$refs.XRtoast.load('请求中...', false)
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/UpdateNickName",{nickName : this.nickTextVal}
      ).then(function(res) {
        ths.loaded =false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.nickText = ths.nickTextVal
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });     
    },
    birthChange(val){
      this.birthday =val;
      this.birthdayVal =val;
	  
      this.$refs.XRtoast.load('请求中...', false)
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/UpdateBirthday",{birthday : this.birthday}
      ).then(function(res) {
        ths.loaded =false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });     
    },
    update(e){
      if(this.memberId <=0){
          this.$refs.XRtoast.failed('您未登录', true)
          return
      }
      
      this.$refs.XRtoast.load('正在上传...', false)
      let file = e.target.files[0]; 
      if(!file || !file.name){
          this.$refs.headpicFile.value=''
          this.$refs.XRtoast.failed('上传失败，请重试', true)
          return false;
      }
	  if (file.type){
      if(!/image\/\w+/.test(file.type)){ 
        this.$refs.headpicFile.value=''
        this.$refs.XRtoast.failed('文件必须为图片！', true)
        return false; 
      }
      }	  
      if ((file.size / 1024 / 1024 ).toFixed(2) > 2) {
        this.$refs.headpicFile.value=''
        this.$refs.XRtoast.failed('头像不允许超过2M！', true)
        return false;
      }
      
      let param = new FormData(); //创建form对象
      param.append('file',file);//通过append向form对象添加数据
      param.append('filename',file.name);
      param.append('path','headpic');
      param.append('userid',this.memberId)
      //console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      };  //添加请求头

      var ths = this
      this.$post('/Shop/UserServer/UploadHeadPic',param,config)
      .then(function(res){
        ths.$refs.XRtoast.hide()
        ths.$refs.headpicFile.value=''
        if(res.IsSuccess){
          ths.getUserInfo()
        }else{
          ths.$refs.XRtoast.failed(res.Msg, true)
        }
      })        
    },
    
    getAreaList(){
      var ths = this;   
      ths.$post(
        "/Shop/BaseServer/GetAreaAllListGroup"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{     
          address= JSON.parse(res.Data) 
          ths.addressSlots[0].values = Object.keys(address)   
          
          if(ths.$route.query.id){ 
            ths.getInfo()
          }else{
            ths.loaded = false
            ths.$refs.XRtoast.hide()
          }    
        }
      });
    },
    addressChange (value, index) {
      switch (index) {
        case 0:
          this.addressProvince = value
          var cirtyList = address[value]
          var keys = Object.keys(cirtyList)          
          this.addressSlots[1].values = keys
          this.addressCity = keys[0]
          
          var areaList = address[this.addressProvince][this.addressCity]        
          this.addressSlots[2].values = areaList
          this.addressArea = areaList[0]
          break
        case 1:      
          this.addressCity = value
          var arr1 = address[this.addressProvince][value]          
          this.addressSlots[2].values = arr1
          this.addressArea = arr1[0]
          break
        case 2:
          this.addressArea = value
          break
      }
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
      this.addressEditInfo.Province = this.addressProvince
      this.addressEditInfo.City = this.addressCity
      this.addressEditInfo.Area = this.addressArea
    },
    closeAddressBottomSheet () {
      this.addressBottomSheet = false
    },
    openAddressBottomSheet () {
      this.addressBottomSheet = true
    },
    SaveAddress(){      
      this.closeAddressBottomSheet()
      this.$refs.XRtoast.load('请求中...', false)
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/UpdateAddress", this.addressEditInfo
      ).then(function(res) {
        ths.loaded =false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.getUserInfo()
        }
      });     
    }
  }
}
</script>
<style>
#app .personPage{
  background: white;
  bottom: unset;
}
.personPage .person-row{  
  padding: 10px 10px 0;
  overflow: hidden;
  border-bottom:1px solid #efefef;
}
.personPage .person-col{
  float: left;
}
.personPage .person-col .fa{
  line-height:48px;
}

.personPage .person-title{
  line-height: 48px;
  text-align: left;
  text-indent: 10px;
}
.personPage .person-row-img .person-title{
  line-height: 70px;
}
.personPage .person-content{
  line-height: 48px;
  float: right;
  text-indent: 10px;
}
.personPage .person-content.headpicRow
{
  position: relative;
  height: 50px;
  width: 50px;
}
.personPage .person-content.headpicRow .headpicInput{
  width: 10px;
  height: 10px;
  position: absolute;
  z-index: 1;
}
.personPage .person-row-img .person-headpic {
  height: 50px;
  width: 50px;
  overflow: hidden;
  border-radius: 50%;
  z-index: 2;
}

.personPage .person-row-img .person-content{
  line-height: 110px;
}
.personPage .person-rightIcon{
  float: right;
  line-height:none;
}
.personPage .person-rightIcon .fa{
  text-align: center;
  line-height:48px;
}
.personPage .person-row-img .person-rightIcon .fa{
  line-height:65px;
  visibility: hidden;
}

.personPage .demo-flat-button{
  height: 48px;
  line-height: 48px;
}
.personPage .demo-flat-button.link-btn{
  color:red;
}

.personPage-nick {
  padding: 10px 20px 20px 10px;
}
.personPage-nick .demo-raised-button {
  margin-top: 30px;
  height: 50px;
}

.personPage .person-row .person-rightIcon .mu-flat-button{
  min-width: 45px;
}
.personPage .desc{ margin-top:10px;  padding:22px 20px 40px; overflow:hidden; font-size:12px;color:#5A5655; }
.personPage .desc .icon { width:25px; margin-right:15px;}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/person.vue